import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import LoginView from "@/views/LoginView";
import store from "@/store";
import ProductExcelUploadView from "@/views/ProductExcelUploadView";
import ProductTableView from "@/views/ProductTableView";
import ProductImageUploadView from "@/views/ProductImageUploadView";
import ProductProcessView from "@/views/ProductProcessView";
import OtherDetailsProcessView from "@/views/OtherDetailsProcessView";
import OtherDetailsImportExcelView from "@/views/OtherDetailsImportExcelView";
import InventoryImportExcelView from "@/views/InventoryImportExcelView";
import InventoryTableView from "@/views/InventoryTableView";
import InventoryStockInView from "@/views/InventoryStockInView";
import InventoryStockOutView from "@/views/InventoryStockOutView";
import InventoryTransferOutView from "@/views/InventoryTransferOutView";
import InventoryTransferInView from "@/views/InventoryTransferInView";
import InventoryWriteOffView from "@/views/InventoryWriteOffView";
import InventoryStockOutTempTableView from "@/views/InventoryStockOutTempTableView";
import InventoryLogView from "@/views/InventoryLogView";
import ProductMinStockLvView from "@/views/ProductMinStockLvView";
import StockTakeMainListView from "@/views/StockTakeMainListView";
import StockTakeDetailsListView from "@/views/StockTakeDetailsListView";
import StockTakeDetailsAddView from "@/views/StockTakeDetailsAddView";
import StockTakeLogView from "@/views/StockTakeLogView";
import SystemAutoLogoutView from "@/views/SystemAutoLogoutView";
import SystemLicenseView from "@/views/SystemLicenseView";
import SystemUserOnlineListView from "@/views/SystemUserOnlineListView";
import SystemUserManageListView from "@/views/SystemUserManageListView";
import SystemLogTableView from "@/views/SystemLogTableView";
import SystemUserChangePasswordView from "@/views/SystemUserChangePasswordView";
import SystemRoleManageView from "@/views/SystemRoleManageView";
import ErrorNoPermissionPageView from "@/views/ErrorNoPermissionPageView";
import SystemResetView from "@/views/SystemResetView";
import InventoryDeliveryListView from "@/views/InventoryDeliveryListView";
import OtherDetailsMainCategoryView from "@/views/OtherDetailsMainCategoryView.vue";
import OtherDetailsSizeDetailsView from "@/views/OtherDetailsSizeDetailsView.vue";

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginView
    },

    // Home Page
    {
        path: '/',
        name: 'home',
        component: HomeView,
        meta: {
            requireLogin: true,
        }
    },
    // Product
    {
        path: '/product',
        name: 'product-table',
        component: ProductTableView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/product/min-stock-lv',
        name: 'product-min-stock-lv',
        component: ProductMinStockLvView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/product/upload',
        name: 'product-upload',
        component: ProductExcelUploadView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/product/images',
        name: 'product-upload-images',
        component: ProductImageUploadView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/product/:code',
        name: 'product-process',
        component: ProductProcessView,
        meta: {
            requireLogin: true,
        }
    },
    // Other Details
    {
        path: '/other-details/:type',
        name: 'other-details-process',
        component: OtherDetailsProcessView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/other-details/main/sizedetail',
        name: 'other-details-main-size',
        component: OtherDetailsSizeDetailsView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/other-details/main/mainCat',
        name: 'other-details-main-cat',
        component: OtherDetailsMainCategoryView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/other-details/import/:type',
        name: 'other-details-excel-import',
        component: OtherDetailsImportExcelView,
        meta: {
            requireLogin: true,
        }
    },
    // Inventory
    {
        path: '/inventory/import',
        name: 'inventory-excel-import',
        component: InventoryImportExcelView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory',
        name: 'inventory-list',
        component: InventoryTableView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/dn-list',
        name: 'inventory-dn-list',
        component: InventoryDeliveryListView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/stock-in',
        name: 'inventory-stock-in',
        component: InventoryStockInView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/stock-out',
        name: 'inventory-stock-out',
        component: InventoryStockOutView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/transfer-out',
        name: 'inventory-transfer-out',
        component: InventoryTransferOutView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/transfer-in',
        name: 'inventory-transfer-in',
        component: InventoryTransferInView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/write-off',
        name: 'inventory-write-off',
        component: InventoryWriteOffView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/stock-out-temp',
        name: 'inventory-stock-out-temp',
        component: InventoryStockOutTempTableView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/inventory/log',
        name: 'inventory-log',
        component: InventoryLogView,
        meta: {
            requireLogin: true,
        }
    },
    // Stock Take
    {
        path: '/stock-take',
        name: 'stock-take',
        component: StockTakeMainListView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/stock-take/details/:id',
        name: 'stock-take-details',
        component: StockTakeDetailsListView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/stock-take/details/add/:id',
        name: 'stock-take-details-add',
        component: StockTakeDetailsAddView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/stock-take/log',
        name: 'stock-take-log',
        component: StockTakeLogView,
        meta: {
            requireLogin: true,
        }
    },
    // System
    {
        path: '/system/auto',
        name: 'system-auto',
        component: SystemAutoLogoutView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/system/licence',
        name: 'system-license',
        component: SystemLicenseView,
    },
    {
        path: '/system/online',
        name: 'system-online',
        component: SystemUserOnlineListView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/system/user',
        name: 'system-user-list',
        component: SystemUserManageListView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/system/log',
        name: 'system-log',
        component: SystemLogTableView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/system/change-pw',
        name: 'system-change-pw',
        component: SystemUserChangePasswordView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/system/role',
        name: 'system-role',
        component: SystemRoleManageView,
        meta: {
            requireLogin: true,
        }
    },
    {
        path: '/system/reset',
        name: 'system-reset',
        component: SystemResetView,
        meta: {
            requireLogin: true,
        }
    },
    // Error
    {
        path: '/error/no-permission',
        name: 'no-permission',
        component: ErrorNoPermissionPageView,
    },
    // non-correct path handler
    {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: ErrorNoPermissionPageView
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requireLogin) && !store.state.isAuthenticated) {
        // if is need login, and state is not logged in, return user to login page
        next({name: 'login'})
    } else {
        next()
    }
})

export default router
